module.exports = __webpack_public_path__ + "static/media/bookingSets.fab5c2bd.svg";